var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5624 5.85C11.5624 4.69298 11.2233 3.56194 10.5881 2.59992C9.95281 1.63789 9.04991 0.88808 7.99354 0.445307C6.93717 0.00253468 5.77476 -0.113315 4.65333 0.112409C3.53189 0.338132 2.50178 0.89529 1.69327 1.71343C0.884758 2.53156 0.334154 3.57394 0.111086 4.70872C-0.111982 5.84351 0.00250486 7.01975 0.440068 8.0887C0.877632 9.15765 1.61862 10.0713 2.56933 10.7141C3.52004 11.3569 4.63777 11.7 5.78118 11.7C7.31392 11.6983 8.7834 11.0814 9.86721 9.98468C10.951 8.88796 11.5607 7.40099 11.5624 5.85ZM2.56941 5.85C2.56941 5.20721 2.75778 4.57886 3.11069 4.0444C3.46361 3.50994 3.96522 3.09338 4.55209 2.84739C5.13896 2.60141 5.78474 2.53705 6.40776 2.66245C7.03078 2.78785 7.60307 3.09738 8.05224 3.5519C8.50141 4.00643 8.8073 4.58552 8.93123 5.21596C9.05516 5.8464 8.99155 6.49986 8.74846 7.09372C8.50537 7.68758 8.09371 8.19516 7.56554 8.55228C7.03737 8.90939 6.41641 9.1 5.78118 9.1C4.92964 9.09911 4.11323 8.75641 3.51109 8.14711C2.90896 7.53781 2.5703 6.71168 2.56941 5.85Z",
    fill: "url(#paint0_linear_9_46995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_46995",
    x1: 11.5624,
    y1: 5.9852e-7,
    x2: -8.54164,
    y2: 21.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSmall);
export default __webpack_public_path__ + "static/media/circle-small.fcdb1af3fe12472221ee1d2607b4ae12.svg";
export { ForwardRef as ReactComponent };